/** Campo de telefone editável - Acordo infos */
import React, { Component } from "react";
import MaskedInput from "react-text-mask";
import phoneMask from "../../../../../../components/Masks/Phone";
import { Button, notification, Icon, Input } from "antd";
import PropTypes from "prop-types";
import api from "../../../../../../services/api";
import { isSuperUser } from "../../../../../../utils/is-superuser";

export default class DiasEmAtraso extends Component {
  static propTypes = {
    acordo_id: PropTypes.number,
    dias_em_atraso: PropTypes.number
  };

  state = {
    dias_em_atraso: this.props.dias_em_atraso,
    active: false,
    loading: false
  };

  handleChange = event => {
    this.setState({
      dias_em_atraso: event.target.value
    });
  };

  handleEdit = async () => {
    if (this.state.active) {
      this.setState({
        loading: true
      });

      await api
        .post(`/acordo/update-dias-em-atraso/`, {
          acordo_id: this.props.acordo_id,
          dias_em_atraso: this.state.dias_em_atraso
        })
        .then(() => {
          notification.success({
            message: "dias_em_atraso atualizado com sucesso!"
          });
        })
        .catch(err => {
          console.log(err);

          notification.error({
            message: "Não foi possível salvar o dias_em_atraso."
          });
        });
      this.setState({
        active: false,
        loading: false
      });
    } else {
      this.setState({
        active: true
      });
    }
  };

  render() {
    const isAdmin = isSuperUser();

    return (
      <div style={{ display: "flex" }}>
        <Input
          type="number"
          name="dias_em_atraso"
          className="ant-input"
          defaultValue={this.props.dias_em_atraso}
          onChange={this.handleChange}
          disabled={!this.state.active}
        />
        &nbsp;
        {isAdmin && (
          <Button
            loading={this.state.loading}
            type="primary"
            size="small"
            onClick={this.handleEdit}
          >
            {this.state.active ? "Salvar" : <Icon type="edit" />}
          </Button>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoInfos/DiasEmAtraso/index.js